import React from "react";
var __jsx = React.createElement;
import { useTranslation } from "@i18n";
import { Drawer } from "vaul";
import { DrawerPortal } from "@/components/Drawer";
import { Dialog, DialogContent } from "@/components/Dialog";
import { Conditional } from "@componentsShared/Conditional/Conditional";
import { Then } from "@componentsShared/Conditional/Then";
import { Else } from "@componentsShared/Conditional/Else";
import { Icon } from "@syarahtech/ui";
import useIsMobile from "@hooks/useIsMobile";
import useWebView from "@hooks/useWebview";
import useContactNumbers from "@hooks/useContactNumbers";
import { CDN_LINK } from "@globalConfig";
import { trackEvents } from "@/common/events/events";
import support from "@/pages/sell-trade-v2/sell-trade/icons/support.svg";
var ContactSupportModal = function ContactSupportModal(_ref) {
  var isOpen = _ref.isOpen,
    onClose = _ref.onClose,
    _ref$page = _ref.page,
    page = _ref$page === void 0 ? "sell-trade" : _ref$page,
    post_id = _ref.post_id;
  var isMobile = useIsMobile();
  var _useTranslation = useTranslation(["sell_trade_landing"]),
    tShort = _useTranslation.tShort;
  var webview = useWebView();
  var contactNumbers = useContactNumbers();
  var handleCallClick = function handleCallClick() {
    trackEvents("online_contact", {
      post_id: post_id,
      contact_type: "call",
      contact_location: page
    });
    webview.openUri("tel:".concat(contactNumbers.callCenterCallNumber))["catch"](function () {
      document.location.href = "tel:".concat(contactNumbers.callCenterCallNumber);
    });
  };
  var handleWhatsAppClick = function handleWhatsAppClick() {
    trackEvents("online_contact", {
      post_id: post_id,
      contact_type: "whatsapp",
      contact_location: page
    });
    webview.openUri("https://wa.me/".concat(contactNumbers.whatsappCallNumber))["catch"](function () {
      document.location.href = "https://wa.me/".concat(contactNumbers.whatsappCallNumber);
    });
  };
  var content = /*#__PURE__*/React.createElement("div", {
    id: "contact-support-modal-content",
    className: "flex flex-col items-center gap-6 py-4 w-full md:w-[400px] mx-auto"
  }, /*#__PURE__*/React.createElement("img", {
    id: "contact-support-modal-icon",
    src: support,
    className: "h-[77px] w-[77px]",
    alt: "support"
  }), /*#__PURE__*/React.createElement("h2", {
    id: "contact-support-modal-title",
    className: "text-2xl font-bold text-primary-new text-center px-5"
  }, tShort("contact_modal/title", {
    ns: "sell_trade_landing"
  })), /*#__PURE__*/React.createElement("p", {
    id: "contact-support-modal-working-hours",
    className: "text-base text-[#09090B] text-center leading-relaxed"
  }, tShort("contact_modal/working_hours", {
    ns: "sell_trade_landing"
  })), /*#__PURE__*/React.createElement("div", {
    id: "contact-support-modal-buttons-container",
    className: "flex flex-col gap-3 w-full"
  }, /*#__PURE__*/React.createElement("button", {
    id: "contact-support-modal-call-button",
    className: "cursor-pointer text-white flex bg-primary-new items-center justify-between gap-3 px-6 py-4 border-none rounded-lg w-full text-base font-semibold",
    onClick: handleCallClick
  }, /*#__PURE__*/React.createElement("div", {
    id: "contact-support-modal-call-button-content",
    className: "flex items-center gap-2"
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: "material-symbols--call",
    width: 6,
    height: 6,
    className: "text-white"
  }), /*#__PURE__*/React.createElement("span", {
    id: "contact-support-modal-call-button-text"
  }, tShort("contact_modal/call_us", {
    ns: "sell_trade_landing"
  }))), /*#__PURE__*/React.createElement("div", {
    id: "contact-support-modal-call-number"
  }, contactNumbers.callCenterDisplayNumber)), /*#__PURE__*/React.createElement("button", {
    id: "contact-support-modal-whatsapp-button",
    className: "cursor-pointer flex greenBtn items-center justify-between gap-3 px-6 py-4 border-none rounded-lg text-white w-full text-base font-semibold",
    onClick: handleWhatsAppClick
  }, /*#__PURE__*/React.createElement("div", {
    id: "contact-support-modal-whatsapp-button-content",
    className: "flex items-center gap-2"
  }, /*#__PURE__*/React.createElement("img", {
    id: "contact-support-modal-whatsapp-icon",
    className: "w-6 h-6",
    src: CDN_LINK + "/assets/images/wpImg.svg",
    alt: ""
  }), /*#__PURE__*/React.createElement("span", {
    id: "contact-support-modal-whatsapp-button-text"
  }, tShort("contact_modal/whatsapp", {
    ns: "sell_trade_landing"
  }))), /*#__PURE__*/React.createElement("div", {
    id: "contact-support-modal-whatsapp-number"
  }, contactNumbers.whatsappDisplayNumber))));
  return /*#__PURE__*/React.createElement(Conditional, {
    condition: isMobile
  }, /*#__PURE__*/React.createElement(Then, null, /*#__PURE__*/React.createElement(Drawer.Root, {
    open: isOpen,
    onOpenChange: function onOpenChange(open) {
      return !open && onClose();
    },
    onClose: onClose
  }, /*#__PURE__*/React.createElement(DrawerPortal, null, /*#__PURE__*/React.createElement(Drawer.Overlay, {
    id: "contact-support-modal-drawer-overlay",
    className: "fixed inset-0 bg-[#071425] opacity-80 z-[9998]"
  }), /*#__PURE__*/React.createElement(Drawer.Content, {
    id: "contact-support-modal-drawer",
    className: "bg-white flex flex-col rounded-t-[10px] fixed bottom-0 left-0 right-0 z-[9999] py-4 px-6"
  }, /*#__PURE__*/React.createElement("div", {
    id: "contact-support-modal-drawer-close-button",
    className: "absolute left-4 en:right-4 top-4 rounded-sm focus:outline-none disabled:pointer-events-none bg-transparent border-none cursor-pointer",
    onClick: onClose
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: "material-symbols--close-small-outline-rounded",
    width: 6,
    height: 6,
    className: "text-[#4D4D4F]"
  })), content)))), /*#__PURE__*/React.createElement(Else, null, /*#__PURE__*/React.createElement(Dialog, {
    open: isOpen,
    onOpenChange: function onOpenChange(open) {
      return !open && onClose();
    }
  }, /*#__PURE__*/React.createElement(DialogContent, {
    id: "contact-support-modal-dialog",
    className: "min-w-[600px] p-6",
    haveClose: false
  }, /*#__PURE__*/React.createElement("div", {
    id: "contact-support-modal-dialog-close-button",
    className: "absolute left-4 en:right-4 top-4 rounded-sm focus:outline-none disabled:pointer-events-none bg-transparent border-none cursor-pointer",
    onClick: onClose
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: "material-symbols--close-small-outline-rounded",
    width: 6,
    height: 6,
    className: "text-[#4D4D4F]"
  })), content))));
};
export default ContactSupportModal;